import { FC } from 'react';
import { cn } from '../../../utils/helpers';
import useModal from '../../partials/Modal/useModal';
import Button from '../Button';

interface Props {
  text: string;
  onClickDelete: () => void;
  isMany?: boolean;
  isLoading?: boolean;
}

const DeleteItemModal: FC<Props> = ({ text, onClickDelete, isMany, isLoading }) => {
  const { hideModal } = useModal();

  return (
    <div className="bg-[#F7F7F7]">
      <div className="p-8">
        Are you sure you want to delete {isMany ? 'these' : 'this'} {text}?
      </div>
      <div className={cn('p-4', 'flex gap-2 justify-end', 'border-t border-gray')}>
        <Button
          onClick={onClickDelete}
          variant="secondary"
          className="border-negative text-negative py-2 px-4"
          disabled={isLoading}
        >
          Delete
        </Button>
        <Button
          onClick={hideModal}
          className="bg-positive text-raisin-black font-medium py-2 px-4"
          disabled={isLoading}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default DeleteItemModal;
